import { Link as MUILink } from "@mui/material";
import Box from "@mui/material/Box";
import { type LinkBaseProps } from "@mui/material/Link/Link";
import { Icons } from "@repo/ui";
import { type FC } from "react";
import { type BasicTriggerProps } from "./";

type TriggerProps = {
	icon?: JSX.Element;
	disabled?: boolean;
} & BasicTriggerProps &
	LinkBaseProps;

const Trigger: FC<TriggerProps> = ({
	children,
	onClick,
	type = "button",
	icon,
	disabled,
	sx,
	...rest
}) => {
	return (
		<MUILink
			type={type}
			onClick={onClick}
			component="button"
			underline="none"
			{...rest}
			sx={
				disabled
					? { ...sx, color: "#BDBDBD", pointerEvents: "none" }
					: { ...sx }
			}
		>
			{icon ? (
				<>
					<Box component="span" sx={{ verticalAlign: "middle" }}>
						{children}
					</Box>
					<Box component="span" sx={{ whiteSpace: "nowrap" }}>
						&nbsp;
						{icon}
					</Box>
				</>
			) : (
				children
			)}
		</MUILink>
	);
};
export default Trigger;

export const TriggerLink: FC<TriggerProps> = ({
	children,
	onClick,
	type = "button",
	icon,
	sx,
	...rest
}) => {
	return (
		<Trigger
			type={type}
			onClick={onClick}
			component="button"
			icon={icon}
			{...rest}
			sx={{
				...sx,
				verticalAlign: "unset",
				fontWeight: "normal",
				fontFamily: `"NNNittiGroteskTextRegular", sans-serif`,
			}}
			underline="always"
		>
			{children}
		</Trigger>
	);
};

export const TriggerArrowDown: FC<LinkBaseProps & BasicTriggerProps> = ({
	children,
	...props
}) => (
	<Trigger
		{...props}
		icon={
			<Icons.ArrowIconDown
				sx={{
					width: "1.6rem",
					height: "1.6rem",
					ml: 2,
				}}
			/>
		}
	>
		{children}
	</Trigger>
);

export const TriggerArrowRight: FC<LinkBaseProps & BasicTriggerProps> = ({
	children,
	...props
}) => (
	<Trigger
		{...props}
		icon={
			<Icons.Arrow
				sx={{
					width: "1.6rem",
					height: "1.6rem",
					ml: 2,
				}}
			/>
		}
	>
		{children}
	</Trigger>
);
